//#region DevExtreme Imports

import 'devextreme/ui/toolbar'

//#endregion

import { USER_SESSION_SERVICE_NAME } from '../../../../services/user-session'

import { ConsumerDetailsPaymentsController } from "./consumers-details-payments.controller"

//#region Asset Imports

import './consumers-details-payments.scss'
import * as TEMPLATE from './consumers-details-payments.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'consumerDetailsPayments'

export class ConsumerDetailsPaymentsComponent implements ng.IComponentOptions {

    controller = [USER_SESSION_SERVICE_NAME, ConsumerDetailsPaymentsController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}
